module.exports = __webpack_public_path__ + "img/4.c562f5be.jpg";